import { ArrowUp, Mail } from 'lucide-react'
import { locales } from '../content/data'
import { useLocale } from '../context/LocaleContext'
import type { Locale } from '../content/types'
import { GitHubIcon } from './GitHubIcon'
import { LinkedInIcon } from './LinkedInIcon'

interface HeaderProps {
  onNavigate: (id: string) => void
}

export function Header({ onNavigate }: HeaderProps) {
  const { locale, setLocale, content } = useLocale()
  const { ui } = content

  return (
    <header className="site-header">
      <button className="back-to-top" onClick={() => onNavigate('top')} aria-label={ui.backToTop}>
        <span className="back-to-top-icon"><ArrowUp aria-hidden="true" /></span>
        <span className="back-to-top-name">Anton Kogan</span>
      </button>
      <div className="header-actions">
        <div className="language-switcher" role="group" aria-label={ui.languageLabel}>
          {locales.map((item) => (
            <button key={item} className={locale === item ? 'active' : ''} aria-pressed={locale === item} onClick={() => setLocale(item as Locale)}>
              {item.toUpperCase()}
            </button>
          ))}
        </div>
        <a className="icon-link" href="mailto:contact@antonkogan.com" aria-label={ui.email}><Mail size={18} /></a>
        <a className="github-link" href="https://github.com/antonkog" target="_blank" rel="noreferrer" aria-label="GitHub"><GitHubIcon /><span>GitHub</span></a>
        <a className="linkedin-link" href="https://www.linkedin.com/in/anton-kogan-developer/" target="_blank" rel="noreferrer" aria-label={ui.linkedin}><LinkedInIcon /><span>{ui.linkedin}</span></a>
      </div>
    </header>
  )
}
